module.exports = __webpack_public_path__ + "static/media/plan_lekcji_2.da60cfb1.png";